import axios from 'axios';

const deleteDepartment = async (token, id) => {
  try {
      const formData = new FormData();
    formData.append('id', id);

    const res = await axios.post(
      '/receipt-departments/delete',
      formData, // Use formData as the data payload
      {
        headers: {
         Accept: 'application/json',
          'Content-Type': 'multipart/form-data', // Set Content-Type to multipart/form-data
          Authorization: 'Bearer ' + token,
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export default deleteDepartment;
